import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import '../subscriptionTabs/SubscriptionTab.css'

const SubscriptionTab = () => {
    const [selectedSugarType, setSelectedSugarType] = useState("Sugar Daddy");
  return (
    <div className='tabs-detail-sec subscription-tab'>
        <div className='subscription-box'>
            <h2>Subscription</h2>
            <div className='subscription-content-details'>
                <div className='subscription-group active-btn mb-3 d-flex flex-wrap align-items-center justify-content-between radio-box-checked'>
                    <div className="form-check mb-0 w-100">
                        <input className="form-check-input w-100" type="radio" name="sugarType" id="sugarDaddy" value="Sugar Daddy" checked={selectedSugarType==="Sugar Daddy" } onChange={()=> setSelectedSugarType("Sugar Daddy")} />
                        <label className="form-check-label amount d-flex gap-2 w-100" htmlFor="sugarDaddy">
                            <span>Monthly</span>
                            <span>$29.99</span>
                        </label>
                    </div>
                    {/* <Link rel='stylesheet' to="/" className='btn btn-border'>Selected</Link> */}
                </div>
                <div className='subscription-group mb-3  d-flex flex-wrap align-items-center  radio-box-checked'>
                    <div className="form-check mb-0 w-100">
                        <input className="form-check-input w-100" type="radio" name="sugarType" id="sugarMummy" value="Sugar Mummy" checked={selectedSugarType==="Sugar Mummy" } onChange={()=> setSelectedSugarType("Sugar Mummy")} />
                        <label className="form-check-label amount d-flex gap-2" htmlFor="sugarMummy">
                            <span>Annual</span>
                            <span>$299.99 </span>
                        </label>
                    </div>
                </div>
                <div className='btn btn-box d-flex justify-content-end w-100'>
                    <Link rel='stylesheet' to="/" className='btn btn-border'>Cancel</Link>
                </div>
            </div>
        </div>
    </div>
  )
}

export default SubscriptionTab
